import { getFormattedShopifyId } from 'shared/utils/shopify/ids';
import { ITEM_INDEX_LIST } from './constants';
import { CheckoutBaBType, ShopifySubscriptionType } from './types';

export function getItemIndexInList({
  quantity,
  type
}: {
  quantity: number;
  type: CheckoutBaBType;
}) {
  let itemIndexInList = '';
  if (type === CheckoutBaBType.SUBSCRIPTION) {
    itemIndexInList = quantity === 1 ? `${ITEM_INDEX_LIST}-0` : `${ITEM_INDEX_LIST}-1`;
  } else {
    itemIndexInList = `${ITEM_INDEX_LIST}-2`;
  }
  return itemIndexInList;
}

export function extractNumberFromCurrencyString(currencyString: string): number | null {
  // Match any character that is not a digit and remove it
  const numberString = currencyString.replace(/[^0-9.]/g, '');

  // Convert the result to a number, handling cases where it might not be a valid number
  const number = numberString ? parseFloat(numberString) : null;

  return number;
}

export function addWelcomeKit(product: ShopifySubscriptionType) {
  if (!product.isWelcomeKitIncluded) return [];

  const [targetWelcomeKit] = product.welcomeKitIds || [];
  const subscriptionType = product.productType;

  return targetWelcomeKit
    ? [
        {
          merchandiseId: getFormattedShopifyId('ProductVariant', targetWelcomeKit),
          quantity: 1,
          attributes: [
            {
              // double underscore makes the custom attribute hidden on the checkout
              key:
                subscriptionType === 'oneTime'
                  ? '__custom.otp_welcome_kit'
                  : '__custom.welcome_kit',
              value: 'true'
            }
          ]
        }
      ]
    : [];
}
